<ng-container>
  <!-- Filter -->
  <ng-container *ngIf="isFilterable" [matColumnDef]="this.rowActionIcon">
    <div fxLayout fxLayoutAlign="center center">
      <mat-form-field appearance="outline">
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" />
      </mat-form-field>
    </div>
  </ng-container>

  <!-- Table -->
  <section class="example-container" tabindex="0">
    <table
      class="table"
      aria-describedby="table"
      mat-table
      [dataSource]="tableDataSource"
      matSort
      (matSortChange)="sortTable($event)">
      <ng-container matColumnDef="selected">
        <th mat-header-cell *matHeaderCellDef>
          Selected Element:<br />{{ selectedElement?.name }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-radio-button [value]="element"> </mat-radio-button>
        </td>
      </ng-container>

      <!-- action column -->

      <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.name">
        <!-- if sortable column header -->
        <ng-container *ngIf="tableColumn.isSortable; else notSortable">
          <th
            mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]="tableColumn.name"
            [arrowPosition]="tableColumn.position === 'right' ? 'before' : 'after'">
            {{ tableColumn.name }}
          </th>
        </ng-container>
        <!-- else not sortable -->
        <ng-template #notSortable>
          <th
            mat-header-cell
            *matHeaderCellDef
            [class.text-right]="tableColumn.position == 'right'">
            {{ tableColumn.name }}
          </th>
        </ng-template>

        <!-- column data -->
        <td mat-cell *matCellDef="let element">
          {{ element | dataPropertyGetter : tableColumn.dataKey }}
        </td>
      </ng-container>
      <ng-container *ngIf="isEditable" [matColumnDef]="Action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
          <div *ngIf="!isShipmentHistory" style="display: flex">
            <a>
              <img src="assets/images/edit.svg" alt="edit" (click)="(row.receiver_id)" />
            </a>
            <a class="ml-2">
              <img
                src="assets/images/trash-bin-delete.svg"
                alt="delete"
                (click)="deleteAddress(row.receiver_id)" />
            </a>
          </div>
          <div *ngIf="isShipmentHistory && element.status == 'pending'">
            <button class="primary-btn" type="button" (click)="emitRowAction(element, 'true')">
              Accept
            </button>
            <button
              class="ml-2 secondary-btn"
              type="button"
              (click)="emitRowAction(element, 'false')">
              Reject
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </section>
  <!-- Pagination -->
  <mat-paginator
    *ngIf="isPageable"
    [pageSizeOptions]="paginationSizes"
    [pageSize]="defaultPageSize">
  </mat-paginator>
</ng-container>
